/**
 * tone : ton sémantique du design system opérations (success | warning | danger | info | neutral)
 * variant : variante Bootstrap conservée pour compatibilité
 */
export const WORKFLOW_CONFIG = {
    forecast_pending: {
        text: 'En attente',
        variant: 'warning',
        tone: 'warning',
        description: 'Le check forecast n’a pas encore été effectué.',
    },
    forecast_checked_not_triggered: {
        text: 'Non déclenché',
        variant: 'success',
        tone: 'success',
        description: 'Forecast vérifié : aucun déclenchement.',
    },
    forecast_checked_triggered: {
        text: 'Déclenché',
        variant: 'danger',
        tone: 'danger',
        description: 'Forecast vérifié : seuil de déclenchement atteint.',
    },
    forecast_checked_triggered_email_pending: {
        text: 'Email en attente',
        variant: 'warning',
        tone: 'warning',
        description: 'Déclenché : l’email au client n’a pas encore été envoyé.',
    },
    forecast_checked_triggered_complete: {
        text: 'Complété',
        variant: 'success',
        tone: 'success',
        description: 'Déclenché et email envoyé : traitement terminé.',
    },
    observation_pending: {
        text: 'Obs. en attente',
        variant: 'primary',
        tone: 'info',
        description: 'Le check observation est planifié et en cours de traitement.',
    },
    observation_done: {
        text: 'Obs. terminée',
        variant: 'success',
        tone: 'success',
        description: 'Le check observation a été effectué.',
    },
    observation_triggered: {
        text: 'Obs. déclenchée',
        variant: 'danger',
        tone: 'danger',
        description: 'Observation vérifiée : seuil de déclenchement atteint.',
    },
    observation_not_triggered: {
        text: 'Obs. non déclenchée',
        variant: 'success',
        tone: 'success',
        description: 'Observation vérifiée : aucun déclenchement.',
    },
};

/** Mapping des 6 `workflow_label` renvoyés par GET /dashboard/operations/forecast. */
export const FORECAST_WORKFLOW_CONFIG = {
    forecast_pending: {
        text: 'À vérifier',
        variant: 'secondary',
        tone: 'neutral',
        overdueTone: 'warning',
        description: 'Le check forecast n’a pas encore été effectué.',
    },
    forecast_checked_not_triggered: {
        text: 'Vérifié – non déclenché',
        variant: 'danger',
        tone: 'danger',
        description: 'Forecast vérifié : aucun déclenchement.',
    },
    forecast_checked_triggered: {
        text: 'Déclenché – sinistre à créer',
        variant: 'success',
        tone: 'success',
        description: 'Forecast déclenché : le sinistre n’a pas encore été créé.',
    },
    forecast_checked_triggered_email_pending: {
        text: 'Sinistre créé – e-mail à envoyer',
        variant: 'warning',
        tone: 'warning',
        description: 'Sinistre créé : l’e-mail au client n’a pas encore été envoyé.',
    },
    observation_pending: {
        text: 'En attente observation',
        variant: 'primary',
        tone: 'info',
        description: 'E-mail envoyé : le check observation reste à faire.',
    },
    observation_done: {
        text: 'Terminé',
        variant: 'success',
        tone: 'success-strong',
        description: 'Observation vérifiée : traitement terminé.',
    },
};

export const getWorkflowConfig = (label, context) => {
    const source = context === 'forecast' ? FORECAST_WORKFLOW_CONFIG : WORKFLOW_CONFIG;
    return source[label] || {
        text: label || '—',
        variant: 'secondary',
        tone: 'neutral',
        description: null,
    };
};

export const isPendingWorkflow = (label) => (
    label === 'forecast_pending'
    || label === 'forecast_checked_triggered_email_pending'
    || label === 'observation_pending'
);

export const isTriggeredWorkflow = (label) => (
    label === 'forecast_checked_triggered'
    || label === 'forecast_checked_triggered_email_pending'
    || label === 'observation_triggered'
);
